import { useState } from "react";
import { adminGet } from "@/lib/adminApi";
import { PILLAR_LABELS } from "@/lib/instant";

const DURATIONS = [5, 10, 15, 20, 30];

export default function Moteur() {
  const [pillar, setPillar] = useState("respirer");
  const [minutes, setMinutes] = useState(15);
  const [result, setResult] = useState(null);

  const run = () => {
    adminGet(`/engine/test?pillar=${pillar}&minutes=${minutes}`).then(setResult).catch(() => {});
  };

  return (
    <div data-testid="admin-moteur-module">
      <h2 className="rav-admin-h2">Moteur Mon Instant — mode test</h2>
      <p className="rav-page-sub">Simulez un ressenti et voyez exactement ce que le moteur proposerait.</p>
      <div className="rav-chips rav-admin-chips-left">
        {Object.entries(PILLAR_LABELS).map(([id, label]) => (
          <button key={id} type="button" className={`rav-chip${pillar === id ? " is-selected" : ""}`} data-testid={`engine-pillar-${id}`} onClick={() => setPillar(id)}>
            {label}
          </button>
        ))}
      </div>
      <div className="rav-chips rav-admin-chips-left">
        {DURATIONS.map((m) => (
          <button key={m} type="button" className={`rav-chip${minutes === m ? " is-selected" : ""}`} data-testid={`engine-min-${m}`} onClick={() => setMinutes(m)}>
            {m} min
          </button>
        ))}
      </div>
      <button type="button" className="rav-primary-button rav-admin-create" data-testid="engine-run" onClick={run}>
        Générer
      </button>

      {result && (
        <div className="rav-admin-list" data-testid="engine-result">
          {result.instant.steps.map((s, i) => (
            <div key={i} className="rav-admin-row">
              <span className="rav-admin-row-label">
                {s.label} — {s.minutes} min — « {s.title} »
              </span>
              <span className="rav-admin-row-sub">{s.description}</span>
              <span className="rav-admin-row-sub">
                Pourquoi ? score {result.explanations[i].score} — {result.explanations[i].why.join(" · ")}
              </span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
